export default __webpack_public_path__ + "static/media/330_dummy2016-anwaltskanzlei01-mobile-de.a86c20e4.png";